import { useEffect } from "react";

import { AppRoutes } from "AppRoutes";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { selectLenses } from "redux/slices/client";
import { useNavigate } from "react-router-dom";
import { setCaseFilters } from "../../redux/slices/clientLens";
import { SimpleLensView } from "generated/graphql";
import LensCard from "routes/lenses/LensCard";

const Lenses = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const lenses = useAppSelector(selectLenses);
  useEffect(() => {
    document.title = "Pattern";
    // Reset case table filters when we go back home
    dispatch(setCaseFilters(undefined));
  }, []);

  const handleLensClick = (lens: SimpleLensView) => {
    navigate(AppRoutes.lensDetailBuilder(lens.id));
  };

  return (
    <div className="flex flex-col gap-4 pt-4">
      {lenses.map((lens) => (
        <LensCard key={lens.id} lens={lens} click={() => handleLensClick(lens)} />
      ))}
    </div>
  );
};

export default Lenses;
